// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2KZSz","rootSmall":"AddTileButton_rootSmall__3Vcvw"};